import React, { useState, useEffect } from 'react';
import {
    Box,
    VStack,
    HStack,
    Select,
    Text,
    Divider,
    FormControl,
    Button,
    Input,
    Textarea,
    useToast,
    Flex,
    FormLabel,
} from '@chakra-ui/react';
import CustomInput from '../../../../components/common/CustomInput'; // Adjust the path if necessary
import CustomLabel from '../../../../components/common/CustomLabel'; // Adjust the path if necessary
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

function EditLedger({ ledgerId }) {
    const toast = useToast();
    const navigate = useNavigate();
    const [ledgerGroupsList, setLedgerGroupsList] = useState([]);
    const [ledgerData, setLedgerData] = useState({});
    const [fieldAdded, setFieldAdded] = useState(false);
    const [ledgerGroup, setLedgerGroup] = useState('');
    const [typeOfBalance, setTypeOfBalance] = useState('');
    const [typeOfBalanceClosing, setTypeOfBalanceClosing] = useState('');


    const handleAddMoreFields = () => {
        setFieldAdded(true);  // Ensure the state is being updated correctly
    };

    const handleHideFields = () => {
        setFieldAdded(false);  // Hide additional fields when this button is clicked
    };


    const fetchLedgerGroups = async () => {
        try {
            const response = await axios.get(`${ACCOUNTS_URL}/common/ledger_group.php`);
            if (Array.isArray(response.data.data)) {
                setLedgerGroupsList(response.data.data);

            } else {
                throw new Error('Invalid data format received');
            }
        } catch (error) {
            toast({
                title: 'Error',
                description: 'Failed to load ledger groups.',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const fetchLedgerData = async () => {
        const ldg_id = localStorage.getItem('ledgerId'); // Use 'ledgerId' from localStorage
        const cmp_id = sessionStorage.getItem('cmp_id'); // Use 'cmp_id' from sessionStorage

        const payload = { ldg_id, cmp_id };

        console.log('====================================');
        console.log(payload); // Make sure you are sending the correct data
        console.log('====================================');

        try {
            const response = await axios.post(
                `${ACCOUNTS_URL}/ledger/view_single_ledger.php`,
                payload
            );

            console.log('====================================');
            console.log("Responseb:", response);
            console.log('====================================');
            setLedgerGroup(response.data.data.led_group_id);

            if (response.data.success) {
                setLedgerData(response.data.data); // Assuming response.data contains the ledger data
            } else {
                toast({
                    title: 'Error',
                    description: response.data.message || 'Failed to load ledger data.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: 'Error',
                description: 'Failed to load ledger data.',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };


    const handleUpdateLedger = async () => {
        // Prepare the payload with fallback values for optional fields
        const x = {
            ledger_id: localStorage.getItem('ledgerId'),
            ledger_group: ledgerData.led_group_id,
            ledger_name: ledgerData.L_name,
            led_description: ledgerData.L_description || '',
            led_opbal: ledgerData.L_opening_balance || '',
            closing_bal: ledgerData.L_closing_balance || '',
            useridlog: sessionStorage.getItem('user_id'),
            cmp_id: sessionStorage.getItem('cmp_id'),
            opbal_type: ledgerData.opbal_type_value,
            bnk_name: ledgerData.bnk_name || '',
            bnk_branch: ledgerData.bnk_branch || '',
            bnk_ifc_code: ledgerData.bnk_ifc_code || '',
            bnk_account_no: ledgerData.bnk_account_no || '',
            cu_address: ledgerData.cu_address || '',
            bnk_address: ledgerData.bnk_address || '',
            bnk_phno: ledgerData.bnk_phno || '',
            bnk_mail: ledgerData.bnk_mail || '',
            bnk_description: ledgerData.bnk_description || '',
            bnk_micr: ledgerData.bnk_micr || '',
            bnk_intagation: ledgerData.bnk_intagation || '',
            cu_mobile: ledgerData.cu_mobile || '',
            cu_email: ledgerData.cu_email || '',
            cu_tin: ledgerData.cu_tin || '',
            cu_gpdays: ledgerData.cu_gpdays || '',
            cu_place: ledgerData.cu_place || ''
        };

        console.log('Ledger data to update:', x);

        try {
            await axios.put(`${ACCOUNTS_URL}/ledger/edit_ledger.php`, x);

            toast({
                title: 'Success',
                description: 'Ledger updated successfully.',
                status: 'success',
                duration: 3000,
                isClosable: true,
            });

            navigate('/accounts/create_ledger');
        } catch (error) {
            console.error('Error updating ledger:', error);
            toast({
                title: 'Error',
                description: 'Failed to update ledger. Please check your data and try again.',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };




    useEffect(() => {
        fetchLedgerGroups();
        fetchLedgerData();
    }, [ledgerId]);

    return (
        <Box bg="white" borderWidth="1px" p={6} borderRadius="20px" w="100%" minH="750px" maxH="750px" overflowY="auto">
            <Text fontSize="2xl" mb={4}>Edit Ledger</Text>
            <Divider mb={4} />

            <VStack spacing={4} align="stretch">
                <HStack spacing={4}>
                    <FormControl isRequired>
                        <CustomLabel labelText="Ledger Name" />
                        <CustomInput
                            placeholder="Enter Ledger Name"
                            value={ledgerData.L_name || ''}
                            onChange={(e) => setLedgerData(prev => ({ ...prev, L_name: e.target.value }))}
                        />
                    </FormControl>

                    <FormControl isRequired>
                        <CustomLabel labelText="Ledger Group" />
                        <Select
                            placeholder="Select Ledger Group"
                            value={ledgerData.led_group_id || ''}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedGroup = ledgerGroupsList.find(group => group.led_group_id === selectedId);
                                setLedgerData(prev => ({
                                    ...prev,
                                    led_group_id: selectedId,
                                    ledgerGroupName: selectedGroup ? selectedGroup.led_group_name : ''
                                }));
                            }}
                        >
                            {ledgerGroupsList.map(group => (
                                <option key={group.led_group_id} value={group.led_group_id}>
                                    {group.led_group_name}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                </HStack>

                <FormControl>
                    <CustomLabel labelText="Description" />
                    <CustomInput
                        placeholder="Enter Description"
                        value={ledgerData.L_description || ''}
                        onChange={(e) => setLedgerData(prev => ({ ...prev, L_description: e.target.value }))}
                    />
                </FormControl>

                <HStack spacing={4}>
                    <FormControl>
                        <CustomLabel labelText="Opening Balance" />
                        <CustomInput
                            placeholder="Enter Opening Balance"
                            value={ledgerData.L_opening_balance || ''}
                            onChange={(e) =>
                                setLedgerData(prev => ({ ...prev, L_opening_balance: e.target.value }))}
                        />
                    </FormControl>
                    <FormControl mt={{ base: 10, md: 6 }} width="15%">
                        <CustomLabel labelText="Type" />
                        <Select
                            value={ledgerData.opbal_type || ''}
                            onChange={(e) => {
                                const selectedType = e.target.value;
                                setLedgerData(prev => ({
                                    ...prev,
                                    opbal_type: selectedType,
                                    opbal_type_value: selectedType === 'Dr' ? 1 : 2,
                                }));
                            }}
                        >
                            <option value="Dr">Dr</option>
                            <option value="Cr">Cr</option>
                        </Select>
                    </FormControl>




                    <FormControl>
                        <CustomLabel labelText="Closing Balance" />
                        <CustomInput
                            placeholder="Enter Closing Balance"
                            value={ledgerData.L_closing_balance || ''}
                            onChange={(e) => setLedgerData(prev => ({ ...prev, L_closing_balance: e.target.value }))}
                        />
                    </FormControl>

                    <FormControl mt={{ base: 10, md: 6 }} width="15%">
                        <CustomLabel />
                        <Select
                            value={typeOfBalanceClosing}
                            onChange={(e) => setTypeOfBalanceClosing(e.target.value)}
                        >
                            <option value="1">Dr</option>
                            <option value="2">Cr</option>
                        </Select>
                    </FormControl>
                </HStack>

                {fieldAdded && (
                    <Box>
                        {ledgerGroup === '28' ? (
                            <>
                                <Text fontWeight="bold">Bank Account Details:</Text>

                                <FormControl isRequired>
                                    <FormLabel>Account Number</FormLabel>
                                    <Input
                                        placeholder="Enter Account Number"
                                        value={ledgerData.bnk_account_no}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_account_no: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Bank Name</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Name"
                                        value={ledgerData.bnk_name}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_name: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Bank Branch</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Branch"
                                        value={ledgerData.bnk_branch}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_branch: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>IFSC Code</FormLabel>
                                    <Input
                                        placeholder="Enter IFSC Code"
                                        value={ledgerData.bnk_ifc_code}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_ifc_code: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Address</FormLabel>
                                    <Textarea
                                        placeholder="Enter Bank Address"
                                        value={ledgerData.bnk_address}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_address: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Phone Number</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Phone Number"
                                        value={ledgerData.bnk_phno}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_phno: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Email</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Email"
                                        value={ledgerData.bnk_mail}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_mail: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Description</FormLabel>
                                    <Textarea
                                        placeholder="Enter Bank Description"
                                        value={ledgerData.bnk_description}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_description: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>MICR Code</FormLabel>
                                    <Input
                                        placeholder="Enter MICR Code"
                                        value={ledgerData.bnk_micr}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_micr: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Integration</FormLabel>
                                    <Select
                                        placeholder="Select Integration"
                                        value={ledgerData.bnk_intagation}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                bnk_intagation: e.target.value,
                                            }))
                                        }
                                    >
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Select>
                                </FormControl>
                            </>
                        ) : (
                            <>
                                <Text fontWeight="bold">Customer Details:</Text>

                                <FormControl isRequired>
                                    <FormLabel>Mobile</FormLabel>
                                    <Input
                                        placeholder="Enter Mobile Number"
                                        value={ledgerData.cu_mobile}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                cu_mobile: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Email</FormLabel>
                                    <Input
                                        placeholder="Enter Email"
                                        value={ledgerData.cu_email}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                cu_email: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Tax Number</FormLabel>
                                    <Input
                                        placeholder="Enter Tax Number"
                                        value={ledgerData.cu_tin}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                cu_tin: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>GP Days</FormLabel>
                                    <Input
                                        placeholder="Enter GP Days"
                                        value={ledgerData.cu_gpdays}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                cu_gpdays: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Address</FormLabel>
                                    <Textarea
                                        placeholder="Enter Address"
                                        value={ledgerData.cu_address}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                cu_address: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Place</FormLabel>
                                    <Input
                                        placeholder="Enter Place"
                                        value={ledgerData.cu_place}
                                        onChange={(e) =>
                                            setLedgerData((prev) => ({
                                                ...prev,
                                                cu_place: e.target.value,
                                            }))
                                        }
                                    />
                                </FormControl>
                            </>
                        )}

                        <Button
                            mt={4}
                            colorScheme="red"
                            onClick={handleHideFields}
                        >
                            Remove Additional Fields
                        </Button>
                    </Box>
                )}


                <Flex justify="space-between">
                    {!fieldAdded && (
                        <Button mt={4} colorScheme="blue" onClick={handleAddMoreFields}>
                            Add More Fields
                        </Button>
                    )}
                    {fieldAdded && (
                        <Button mt={4} colorScheme="red" onClick={handleHideFields}>
                            Hide Extra Fields
                        </Button>
                    )}
                    <Button mt={6} colorScheme="green" onClick={handleUpdateLedger}>
                        Save Ledger
                    </Button>
                </Flex>
            </VStack>
        </Box>
    );
}

export default EditLedger;
